import { nullableString } from '@/api/mappers/_shared';
import type { ConsentDto } from '@/features/patient-record/api/consents';
import type { ConsentStatus, ConsentViewModel } from '@/features/patient-record/types';

const KNOWN_STATUS: ReadonlySet<ConsentStatus> = new Set<ConsentStatus>([
  'PENDING',
  'SIGNED',
  'DECLINED',
  'WITHDRAWN',
]);

/** Accept UPPERCASE (BE current) or lowercase (documented) status values. */
function toUiStatus(wire: string | undefined): ConsentStatus {
  if (wire === undefined) return 'PENDING';
  const upper = wire.toUpperCase() as ConsentStatus;
  return KNOWN_STATUS.has(upper) ? upper : 'PENDING';
}

export function mapConsent(dto: ConsentDto): ConsentViewModel {
  return {
    id: dto.id ?? '',
    consentType: dto.consent_type,
    status: toUiStatus(dto.status),
    signedAt: nullableString(dto.signed_at),
    signedBy: nullableString(dto.signed_by),
    notes: nullableString(dto.notes),
    documentRef: nullableString(dto.document_ref),
  };
}

export function mapConsents(dtos: readonly ConsentDto[]): ConsentViewModel[] {
  return dtos.map(mapConsent);
}
